var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"form-element-radio-demo"}},[_c('radio-default'),_c('radio-color'),_c('radio-api')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }